
































































































































import {
	computed,
	defineComponent,
	onMounted,
	PropType,
	ref,
} from '@vue/composition-api';
import { ContentQueryParam } from '@front-app/modules/content/routing/params';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ContentType, LinkContentItem } from '@front-app/services/GroupsApi/DiscussionModel';
import { PartialUser } from '@front-app/services/UserApi/UserModel';
import { timeAgo } from '@front-app/util/time';
import { getUsername } from '@front-app/util/user';
import { canDeleteLink, canEditLink } from '@front-app/util/permission/content';
import { Size } from '@front-app/components/constants';
import { useReactionButtons } from '@front-app/components/buttons/useReactionButtons';
import AddReactionDropdown from '@front-app/components/dropdowns/AddReactionDropdown.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import DeleteButton from '@front-app/components/buttons/concrete/DeleteButton.vue';
import EditButton from '@front-app/components/buttons/concrete/EditButton.vue';
import ReactionsListDropdown from '@front-app/components/dropdowns/ReactionsListDropdown.vue';
import UserLink from '@front-app/components/buttons/UserLink.vue';
import XButton from '@front-app/components/buttons/concrete/XButton.vue';
import IconDropdown from '@front-app/components/dropdowns/IconDropdown.vue';
import VideoEmbed from '@front-app/components/video/VideoEmbed.vue';
import BaseContentCard from './BaseContentCard.vue';
import ContentCardIcon from '../../icons/LargeRoundIcon.vue';

export default defineComponent({
	components: {
		AddReactionDropdown,
		BaseContentCard,
		ContentCardIcon,
		CtaButton,
		DeleteButton,
		EditButton,
		FontAwesomeIcon,
		IconDropdown,
		ReactionsListDropdown,
		UserLink,
		VideoEmbed,
		XButton,
	},
	props: {
		content: {
			type: Object as PropType<LinkContentItem>,
			required: true,
		},
		disableDeletion: Boolean,
		enableVideoEmbed: Boolean,
	},
	setup(props, ctx) {
		const contentTime = computed(() => timeAgo(ctx.root.$tc.bind(ctx.root), new Date(props.content.createdDateTime)));
		const getUsernameInternal = (user: PartialUser): string => getUsername(ctx.root.$t.bind(ctx.root), user);

		const openEditContentModal = () => {
			const q = ctx.root.$route.query;
			ctx.root.$router.push({ query: { ...q, [ContentQueryParam.EDIT_CONTENT]: props.content.id } });
		};

		// Action buttons
		const isActionsDropdownOpen = ref(false);
		const deleteAllowed = computed(() => canDeleteLink(props.content) && !props.disableDeletion);

		// Reactions
		const contentReactions = computed(() => props.content.reactions);
		const { reactionButtons } = useReactionButtons(contentReactions);
		const activeReactionButtons = computed(() => reactionButtons.value.filter((reactionButton) => reactionButton?.count > 0));

		// Responsive view
		const screenWidth = ref(window.innerWidth);
		onMounted(() => {
			window.onresize = () => {
				screenWidth.value = window.innerWidth;
			};
		});
		// eslint-disable-next-line arrow-body-style
		const getIconSize = () => {
			return screenWidth.value < 810 ? Size.MEDIUM : Size.LARGE;
		};

		return {
			getIconSize,
			getUsername: getUsernameInternal,
			// Constants
			ContentType,
			// Link info
			contentTime,
			// Actions
			isActionsDropdownOpen,
			deleteAllowed,
			canEditLink,
			openEditContentModal,
			// Reactions
			activeReactionButtons,
			reactionButtons,
			// Util
			Size,
		};
	},
});
